(function ($, njm) {
    'use strict';

    njm.views.microFindMyCompany = Backbone.View.extend({
        events: {
            'keyup .filter_results': 'onInputKeyup'
        },

        /**
         * On input keyup
         * @param ev
         */
        onInputKeyup: function (ev) {
            var search = $(ev.currentTarget);
            var searchVal = search.val().toLowerCase();

            if (searchVal === '') {
                this.$('#sitemap_results > div').css({ display: 'inline-block' });
            } else {
                this.$('#sitemap_results > div > a').each(function () {
                    if ($(this).text().toLowerCase().indexOf(searchVal) >= 0) {
                        $(this).parent('div').css({ display: 'inline-block' });
                    } else {
                        $(this).parent('div').css({ display: 'none' });
                    }
                });

                if (searchVal.length > 2) {
                    this.$('.table_input').show();
                }
            }
        }
    });
})(jQuery, njm);
